(function JuzoProductFilter() {
    /**
     * @type {JuzoProductFilter}
     * @private
     */
    var _this = this;

    /**
     * @type {string} filters
     */
    var filters = '[data-js="product-filter"]';

    /**
     * @type {string} products
     */
    var products = '[data-js="product"]';

    /**
     * Filters nodes by identifier and hides doubles(products>productReferences)
     *
     * @method filterByIdentifier
     * @returns {undefined}
     * @param {string} identifier
     * @param {string} duration
     */
    this.filterByIdentifier = function (identifier, duration) {

        var visibleNodesProductIdentifier = [];
        var visibleNodes = [];
        var hiddenNodes = [];

        // separate nodes which are filtered by identifier
        $.each($(products), function (index, element) {
            var $element = $(element);
            if ($(this).find('[data-filter="' + identifier + '"]').length) {
                visibleNodes.push($element);
                if ($element.data('nodetype') === 'Juzo.NodeTypes:ProductPage') {
                    visibleNodesProductIdentifier.push($element.data('product-identifier'))
                }
            } else {
                hiddenNodes.push($element);
            }
        });

        // move visible productReferences to hiddenNodes
        visibleNodes = $(visibleNodes).filter(function (index, element) {
            var $element = $(element);
            if ($element.data('nodetype') === 'Juzo.NodeTypes:ProductReferencePage' &&
                visibleNodesProductIdentifier.indexOf($element.data('product-identifier')) > -1) {
                hiddenNodes.push($element);
                return false;
            }
            return true;
        });

        // apply visibility
        $.each($(visibleNodes), function (index, element) {
            $(element).show(duration);
        });
        $.each($(hiddenNodes), function (index, element) {
            $(element).hide(duration);
        });
    };

    $(document).ready(function () {
        _this.filterByIdentifier('all', 0);
        // if there are filters and we are not in neos backend,
        // we activate the onclick/sorting behavior
        if (filters.length && $('.neos-backend').length === 0) {
            $(filters).on('click', function () {
                var identifier = $(this).data('identifier');
                $(filters).addClass('secondary');
                $(this).removeClass('secondary');
                _this.filterByIdentifier(identifier, 'fast');
            });
        }
    });

})();
